module.exports = __webpack_public_path__ + "img/sweden-infectious-diseases-male.40d09339.png";